import { SIDE_MENU_WIDTH } from '@constants/generic-constants.js';
import { makeTitleCase } from '@utils/utils.js';
import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import tenantConfig from '../../../data/customizer/tenant-config';
import { isCP } from '../../../utils/app-utils';
import styles from './index.module.scss';
import { cpSideMenuItems, sellerSideMenuItems } from './side-menu-constants';

const { Sider } = Layout;

const SideMenu = () => {
  const { t } = useTranslation();
  const [stateOpenKeys, setStateOpenKeys] = useState([]);
  const [sideMenuWidth, setSideMenuWidth] = useState(SIDE_MENU_WIDTH.close);
  const [current, setCurrent] = useState([]);
  const location = useLocation();
  const tenant = useSelector((state) => state?.tenantData?.tenant);
  const { govt_registration_status } = useSelector((state) => state?.userData?.userInfo?.userProfile?.store || {});

  const disableNavigation = govt_registration_status !== 'verified' && !!tenantConfig?.tax_verification_enabled;

  useEffect(() => {
    const arr = location.pathname.split('/');
    const [parent = '', child = ''] = arr.slice(-2);
    setCurrent([child]);

    const formattedParentName = makeTitleCase({ string: parent, seperator: '-' }).replace('-', ' ');
    setStateOpenKeys([formattedParentName]);
  }, [location, sideMenuWidth]);

  const menuItems = isCP() ? cpSideMenuItems(t, tenant) : sellerSideMenuItems(t, disableNavigation);

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(menuItems);

  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find((key) => stateOpenKeys.indexOf(key) === -1);
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  return (
    <div className={styles.sideMenuWrap}>
      <Sider
        width={sideMenuWidth}
        onMouseEnter={() => setSideMenuWidth(SIDE_MENU_WIDTH.open)}
        onMouseLeave={() => setSideMenuWidth(SIDE_MENU_WIDTH.close)}
        theme="light"
      >
        <Menu
          mode={'inline'}
          style={{ height: '100vh', paddingTop: '1rem' }}
          inlineIndent={15}
          onOpenChange={onOpenChange}
          openKeys={sideMenuWidth === SIDE_MENU_WIDTH.open ? stateOpenKeys : []}
          items={menuItems}
          selectedKeys={current}
        />
      </Sider>
    </div>
  );
};

export default SideMenu;
